<template>
  <div class="header">
    <el-header height="100px" width="100%">
      <div class="content">
        <el-row>
          <el-col :span="12">
            <div class="demo-image__placeholder">
              <router-link to="/About"> <el-image style="width: 190px; height: 56px"
                  :src="src"></el-image></router-link>
            </div>
          </el-col>
          <div class="contenter">
            <el-col :span="9">
              <div style="height:100px; text-align: right;">
                <el-image style="width: 24px;height: 24px;" :src="telephone"></el-image>
                <span class="Title">{{ $t("menu.landlineMachine") }}</span>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="placeholder">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ $t("menu.languageName") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">简体</el-dropdown-item>
                    <el-dropdown-item command="b">繁體</el-dropdown-item>
                    <el-dropdown-item command="c">English</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-header>
    <!-- 导航栏 -->
    <el-menu :default-active="numer" class="el-menu-demo" mode="horizontal" background-color="#1D2088" text-color="#fff"
      active-text-color="#2DC6EA">

      <!-- 关于我们 -->
      <el-menu-item index="1">
        <router-link to="/About">{{ $t("menu.AboutUs") }}</router-link>
      </el-menu-item>

      <!-- 检测范围 -->
      <el-submenu index="2">
        <template slot="title"> {{ $t("menu.business") }}</template>
        <el-menu-item-group>
          <el-menu-item index="2-1">
            <router-link to="/RubberMaterial"> {{ $t("menu.Rubber") }} </router-link>
          </el-menu-item>
          <el-menu-item index="2-2"><router-link to="/PlasticMaterials">{{ $t("menu.PlasticMaterials") }}</router-link>
          </el-menu-item>
          <el-menu-item index="2-3"><router-link to="/Oring">{{ $t("menu.OXinQuan") }}</router-link>
          </el-menu-item>
          <!-- <el-menu-item index="2-4"><router-link to="/ElectronicElectrician">{{ $t("menu.DianziDianGong")}}</router-link>
          </el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>

      <!-- 新闻资讯 -->
      <el-submenu index="3">
        <template slot="title">{{ $t("menu.New") }}</template>
        <el-menu-item index="3-1"><router-link to="/CompanyDnamic">{{ $t("menu.CompanyDnamic")}}</router-link></el-menu-item>
        <el-menu-item index="3-2"><router-link to="/IndustryInformation">{{ $t("menu.IndustryInformation")}}</router-link></el-menu-item>
      </el-submenu>

      <!-- 团队 -->
      <el-submenu index="4">
        <template slot="title">{{ $t("menu.Team") }} </template>
        <el-menu-item index="4-1"> <router-link to="/LaboratoryCenter">{{ $t("menu.LaboratoryCenter") }} </router-link>
        </el-menu-item>
        <el-menu-item index="4-2"><router-link to="/Recruitment">{{ $t("menu.Recruitment")}}</router-link></el-menu-item>
      </el-submenu>

      <!-- 客户服务 -->
      <!-- <el-submenu index="5">
        <template slot="title">{{ $t("menu.customer") }} </template>
        <el-menu-item index="5-1"><router-link to="/CustomerInspection">{{ $t("menu.Instructions") }}</router-link></el-menu-item>
        <el-menu-item index="5-2"><router-link to="/TestApplicationForm">{{ $t("menu.Testapplicationform") }}</router-link></el-menu-item>
        <el-menu-item index="5-3"><router-link to="/TheReportQuery">{{ $t("menu.TheReportQuery") }}</router-link></el-menu-item>
        <el-menu-item index="5-4"><router-link to="/TheInspectionProcess">{{ $t("menu.TheInspectionProcess") }}</router-link></el-menu-item>
      </el-submenu> -->

      <!-- 联系方式 -->
      <el-menu-item index="6" style="margin-left: 50px;">
        <router-link to="/SurveyandQuotation">{{ $t("menu.SurveyAndQuotation") }}</router-link>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: ["numer"],
  inject: ['reload'],

  name: "Nav",
  data() {
    return {
      activeIndex2: "1",
      src: require("@/assets/images/LaboratoryLogo/logo.png"),
      srcYi: require("@/assets/images/about/yuyan.svg"),
      telephone: require("@/assets/images/about/icon_dianhua.png"),

    };
  },
  created: function () {


  },
  methods: {


    // 下拉框
    handleCommand(command) {
      switch (command) {
        case "a":// 简体
          localStorage.setItem("v_locale", "SC");
          this.$i18n.locale = "SC";

          this.refresh();

          break;
        case "b"://繁体
          localStorage.setItem("v_locale", "TC");
          this.$i18n.locale = "TC";

          this.refresh();
          break;
        case "c"://英文                    
          localStorage.setItem("v_locale", "EN");
          this.$i18n.locale = "EN";

          this.refresh();
          break;
      }
      this.setMeta();

    },
    //页面刷新
    refresh: function () {
      this.reload()
    },
    // 设置metat和title
    setMeta() {
      // js 里获取i18n的数据要用tc()方法
      let title = this.$i18n.tc('menu.BTitle');
      let key = this.$i18n.tc('menu.KEYWords');
      let DEs = this.$i18n.tc('menu.DEscription');
      document.title = title;

      let meta = this.$root.meta; // 
      let meta1 = this.$root.meta1;//


      // 设置第一个meta的内容
      meta.name = "KEYWords";
      meta.content = key;

      // 设置第二个meta
      meta1.name = "DEscription";
      meta1.content = DEs;
    }
  },
};
</script>


<style lang="less" scoped>
.tongxin {
  display: block;
  padding-bottom: 10px;

}

.menu-item:hover>.menu {
  display: block;
}

#bx ul li>a {
  color: #0c0c0c;
  font-size: 14px;
  padding: 15px;
  display: block;
}

.menu {
  text-align: center;
  width: 620px;
  position: absolute;
  left: 0px;
  display: none;
  // left: 37%;
  // top: 420px;
}

#bx {
  // padding: 15px;
  background: #ffffff;
  float: left;
  // width: 160px;
  padding-left: 53px;
  padding: 20px;

}

ul {
  list-style: none;
  padding: 0px;

}

.headerer {
  height: 75px;
  width: 100%;
  background: #e8e8e8;
  border: 1px solid #eeeeee;
  margin: 0px auto;
}

.align_content {
  display: flex;
  // flex:1;
  position: relative;
}

.align_content .menu-item {
  padding: 20px;
}

.right span {
  padding: 5px;
}

.right {
  flex: 1;
}

.left {
  flex: 1;
}

.el-icon-search {
  margin-left: 10px;
}

.wraper {
  display: flex;
  align-items: center;
  margin: 0px auto;
  width: 1480px;
  height: 75px;
  text-align: center;
}

.contenter {
  line-height: 100px;
}

.Title {
  font-weight: bold;
  color: #1D2088;
  font-size: 24px;
  padding-left: 10px;

}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #1d2088;
}

a {
  text-decoration: none;
  padding: 11px;
}

li a {
  color: #fff;
  font-size: 14px;
}

// .router-link-exact-active {
//   color: #c70000;
// }
.is-active>a {
  color: #2DC6EA;
}

.header {
  position: fixed;
  width: 100%;
  z-index: 10;
}

.el-dropdown-link {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
}

.placeholder>label {
  display: none;
}

.placeholder>.activated {
  // css权重问题
  display: block;
}

/deep/ .el-submenu__title {
  height: 56px;
  line-height: 56px;
  font-size: 14px;
  color: #303133;
  padding: 0 20px;
  list-style: none;
  cursor: pointer;
  position: relative;
  -webkit-transition: border-color .3s, background-color .3s, color .3s;
  transition: border-color .3s, background-color .3s, color .3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}
</style>